import { render, staticRenderFns } from "./PartRequestDetail.vue?vue&type=template&id=d17f2aa8"
import script from "./PartRequestDetail.vue?vue&type=script&lang=ts"
export * from "./PartRequestDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports